import React from 'react';
import { MdConfirmationNumber } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

interface EventTicketActionButtonProps {
  event: {
    activeStatus: string;
    userAttendanceStatus: string;
  };
  priceRangeNoDiscount: string;
  setIsTicketModalOpen: (isOpen: boolean) => void;
  toggleCheckout: () => void;
}

const EventTicketActionButton: React.FC<EventTicketActionButtonProps> = ({
  event,
  priceRangeNoDiscount,
  setIsTicketModalOpen,
  toggleCheckout
}) => {
  const { t } = useTranslation(['events']);

  return (
    <button
      type="submit"
      disabled={event.activeStatus === 'past'}
      className="h-[70px] bg-primary-800 py-4 w-full text-white text-base flex items-center justify-center disabled:opacity-70"
      onClick={
        event.userAttendanceStatus === 'attending'
          ? () => setIsTicketModalOpen(true)
          : toggleCheckout
      }
      data-testid={
        event.userAttendanceStatus === 'attending'
          ? 'button-view-ticket'
          : 'button-get-tickets'
      }
    >
      {event.userAttendanceStatus === 'attending' ? (
        <>
          {t('events:actions.viewTickets')}
          <MdConfirmationNumber className="ml-2" size={20} />
        </>
      ) : (
        <>
          {t('events:actions.getTicketsWithPrice', {
            price: priceRangeNoDiscount
          })}
          <MdConfirmationNumber className="ml-2" size={20} />
        </>
      )}
    </button>
  );
};

export default EventTicketActionButton;
